const ClientColumn = (params: any) => {
    const client = params.row.original.client || params.row.original.policy?.client || params.row.original.product?.client;

    if (!client) return null;
    return (
        <>
            <>
                <span>
                    <span className="client-name link" onClick={() => window.open(`/clients/profile?clientId=${client._id}`, '_blank')}>
                        <b>{client.fullName}</b>
                    </span>
                    <br />
                    <span>{client.idNumber}</span>
                </span>
                <span className="client-name" onClick={() => window.open(`/product-transfers?clientId=${client._id}`, '_blank')}>
                    {'   '}
                    <i className="mdi mdi-filter me-1" />
                </span>
            </>
        </>
    );
};
export default ClientColumn;
